import React from 'react';
import Navbar from './Components/Navbar';
import Dropdown from './Components/Dropdown';
import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
  return (
    <div>
      <Navbar />
    
    </div>
  );
}

export default App;
